import { db } from "./firebase-conection.js";
import { getDatabase, ref, set, push, child, query, orderByChild, equalTo, get, remove } from "firebase/database";

const boardsRef = ref(db, "/boards");
const listsRef = ref(db, "/lists");
const tasksRef = ref(db, "/tasks");

export default {
    async getBoardsByUser(userId = 1) {
        const boardsQuery = query(boardsRef, orderByChild("owner"), equalTo(userId));
        const snapshot = await get(boardsQuery);
        return snapshot;
    },

    async postBoard(name, userId = 1) {
        const newBoardRef = push(boardsRef);
        const board = { id: newBoardRef.key, name: name, owner: userId };
        await set(newBoardRef, board);
        return board;
    },

    async getListsFromBoard(boardId) {
        const listsQuery = query(listsRef, orderByChild("board"), equalTo(boardId));
        const snapshot = await get(listsQuery);
        return snapshot;
    },

    async postList(board, name) {
        const newListRef = push(listsRef);
        const column = { id: newListRef.key, name: name, board:board };
        await set(newListRef, column);
        return column;
    },

    async getTasksFromList(listId) {
        const tasksQuery = query(tasksRef, orderByChild("list"), equalTo(listId));
        const snapshot = await get(tasksQuery);
        return snapshot;
    },

    async postTask(list, title) {
        const newTaskRef = push(tasksRef);
        const task = { id: newTaskRef.key, list, title, completed: false };
        await set(newTaskRef, task);
        return task;
    },

    async deleteTask(taskId) {
        return remove(child(tasksRef, taskId));
    },

    async completedTask(taskId) {
        try {
            const taskRef = ref(db, `tasks/${taskId}/completed`); // Crear la referencia correcta
            const snapshot = await get(taskRef);
            const currentStatus = snapshot.exists() ? snapshot.val() : false; // Si no existe, asumir false
    
            await set(taskRef, !currentStatus); // Cambiar el estado
    
            console.log(`Tarea ${taskId} marcada como ${!currentStatus ? "completada" : "pendiente"}.`);
            return !currentStatus;
        } catch (error) {
            console.error("Error al actualizar la tarea:", error);
            return false;
        }
    },
};
